import { Alert, Grid, Paper, Stack, styled } from "@mui/material";

export const StyledNotificacionNuevoForm = {
    PageContainer: styled("div")({
        display: "flex",
        justifyContent: "center",
        width: "100%",
    }),
    Container: styled(Paper)({
        width: "100%",
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
    }),
    Content: styled("div")({
        width: "100%",
        padding: 24,
    }),
    InfoAlert: styled(Alert)(({ theme }) => ({
        marginBottom: theme.spacing(2),
    })),
    FormStack: styled(Stack)({
        width: "100%",
    }),
    FormGrid: styled(Grid)({
        width: "100%",
        margin: 0,
    }),
};